import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConstants } from 'src/app/commons/app-constants';

export type GlobalSearchCategory =
  | 'TRANSPORT_UNIT'
  | 'SHIPMENT'
  | 'BUSINESS_PARTNER'
  | 'PRODUCT'
  | 'LOADING_SITE'
  | 'USER'
  /** Client-side-only category — sidebar menu pages matched by label, never returned by the
   *  backend /search/global endpoint. See GlobalSearchComponent.buildMenuGroup(). */
  | 'MENU_ITEM';

export interface GlobalSearchResult {
  id: number;
  encodedId: string | null;
  title: string | null;
  subtitle: string | null;
  category: GlobalSearchCategory;
  route: string;
  /** SHIPMENT category only (Part B) — null for every other category. */
  amount: number | null;
  /** SalesPaymentStatus or PurchasePaymentStatus name, whichever applies to this shipment's trade
   *  direction (e.g. 'FULLY_PAID', 'OVERDUE', 'PENDING') — SHIPMENT category only. */
  paymentStatus: string | null;
}

export interface GlobalSearchResponse {
  transportUnits: GlobalSearchResult[] | null;
  shipments: GlobalSearchResult[] | null;
  businessPartners: GlobalSearchResult[] | null;
  products: GlobalSearchResult[] | null;
  loadingSites: GlobalSearchResult[] | null;
  users: GlobalSearchResult[] | null;
}

@Injectable({ providedIn: 'root' })
export class GlobalSearchService {
  private readonly apiUrl = `${AppConstants.API_URL}api/v1/search/global`;

  constructor(private http: HttpClient) {}

  search(term: string, limit = 8): Observable<GlobalSearchResponse> {
    return this.http.get<GlobalSearchResponse>(this.apiUrl, { params: { term, limit: String(limit) } });
  }
}
